<main class="page-main">
	<section class="page-section" id="sectionOverview">
		<h2 id="sectionTitleOverview" class="page-section-no-link-title">All components</h2>
		<ul class="overview-list">
			<li *ngFor=" let item of filterItems(navData, 'components')" class="overview-list-item">
				<div class="overview-list-item-container">
					<div class="overview-list-item-detail-image" (click)="redirectTo(item.route)">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
							<path
								d="M448 208c-18.53 0-36.09 10-48.16 27.42C398.9 236.8 396.3 240 392.4 240C387.8 240 384 236.3 384 231.6V176C384 149.5 362.5 128 336 128l-55.64 0C275.8 127.1 272 124.3 272 119.6c0-3.906 3.188-6.531 4.547-7.484C293.1 100.1 304 82.55 304 64c0-35.3-35.89-64-80-64S144 28.7 144 64c0 18.55 9.1 36.09 27.42 48.14C172.8 113.1 176 115.7 176 119.6c0 4.609-3.75 8.359-8.359 8.359L48 128C21.53 128 0 149.5 0 176v55.64C0 253.9 18.11 272 40.36 272c13.2 0 25.84-6.859 33.8-18.36C77.69 248.5 85.2 240 96 240c17.34 0 32 21.98 32 48s-14.66 48-32 48c-10.8 0-18.31-8.547-21.86-13.67C66.19 310.9 53.55 304 40.36 304C18.11 304 0 322.1 0 344.4V464C0 490.5 21.53 512 48 512h119.6C189.9 512 208 493.9 208 471.6c0-13.19-6.859-25.83-18.36-33.8C184.5 434.3 176 426.8 176 416c0-17.34 21.98-32 48-32s48 14.66 48 32c0 10.8-8.547 18.31-13.66 21.84C246.9 445.8 240 458.4 240 471.6C240 493.9 258.1 512 280.4 512H336c26.47 0 48-21.53 48-48v-119.6c0-4.609 3.75-8.358 8.359-8.358c3.906 0 6.547 3.203 7.484 4.547C411.9 358 429.5 368 448 368c35.3 0 64-35.89 64-80S483.3 208 448 208zM448 336c-10.8 0-18.31-8.547-21.86-13.67C418.2 310.9 405.5 304 392.4 304C370.1 304 352 322.1 352 344.4V464c0 8.828-7.172 16-16 16h-55.64C275.8 480 272 476.3 272 471.6c0-3.906 3.188-6.531 4.547-7.484C293.1 452.1 304 434.5 304 416c0-35.3-35.89-64-80-64s-80 28.7-80 64c0 18.55 9.1 36.09 27.42 48.14C172.8 465.1 176 467.7 176 471.6C176 476.3 172.3 480 167.6 480H48C39.17 480 32 472.8 32 464v-119.6C32 339.8 35.75 336 40.36 336c3.906 0 6.547 3.203 7.484 4.547C59.91 358 77.45 368 96 368c35.3 0 64-35.89 64-80S131.3 208 96 208c-18.53 0-36.09 10-48.16 27.42C46.89 236.8 44.25 240 40.36 240C35.75 240 32 236.3 32 231.6V176C32 167.2 39.17 160 48 160h119.6C189.9 160 208 141.9 208 119.6c0-13.19-6.859-25.83-18.36-33.8C184.5 82.31 176 74.8 176 64c0-17.34 21.98-32 48-32s48 14.66 48 32c0 10.8-8.547 18.31-13.66 21.84C246.9 93.8 240 106.4 240 119.6C240 141.9 258.1 160 280.4 160H336C344.8 160 352 167.2 352 176v55.64C352 253.9 370.1 272 392.4 272c13.2 0 25.84-6.859 33.8-18.36C429.7 248.5 437.2 240 448 240c17.34 0 32 21.98 32 48S465.3 336 448 336z" />
						</svg>
					</div>
					<div class="overview-list-item-detail-container" (click)="redirectTo(item.route)">
						<span class="overview-list-item-detail-title">
							{{item.name}}
						</span>
						<span class="overview-list-item-detail-sub-title">
							{{item.description}}
						</span>
					</div>
					<span class="overview-list-item-links">
						<span class="overview-list-item-link" *ngIf="item.codeLink">
							<a [attr.href]="item.codeLink" target="_blank"><svg width="20" height="20"
									viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fill-rule="evenodd" clip-rule="evenodd"
										d="M8 0C3.58 0 0 3.58 0 8C0 11.54 2.29 14.53 5.47 15.59C5.87 15.66 6.02 15.42 6.02 15.21C6.02 15.02 6.01 14.39 6.01 13.72C4 14.09 3.48 13.23 3.32 12.78C3.23 12.55 2.84 11.84 2.5 11.65C2.22 11.5 1.82 11.13 2.49 11.12C3.12 11.11 3.57 11.7 3.72 11.94C4.44 13.15 5.59 12.81 6.05 12.6C6.12 12.08 6.33 11.73 6.56 11.53C4.78 11.33 2.92 10.64 2.92 7.58C2.92 6.71 3.23 5.99 3.74 5.43C3.66 5.23 3.38 4.41 3.82 3.31C3.82 3.31 4.49 3.1 6.02 4.13C6.66 3.95 7.34 3.86 8.02 3.86C8.7 3.86 9.38 3.95 10.02 4.13C11.55 3.09 12.22 3.31 12.22 3.31C12.66 4.41 12.38 5.23 12.3 5.43C12.81 5.99 13.12 6.7 13.12 7.58C13.12 10.65 11.25 11.33 9.47 11.53C9.76 11.78 10.01 12.26 10.01 13.01C10.01 14.08 10 14.94 10 15.21C10 15.42 10.15 15.67 10.55 15.59C13.71 14.53 16 11.53 16 8C16 3.58 12.42 0 8 0Z"
										transform="scale(64)" fill="#1B1F23" />
								</svg>Github
							</a>
						</span>
						<!-- <span class="overview-list-item-link" *ngIf="item.designLink"><a [attr.href]="item.designLink"
								target="_blank"><svg id="Layer_1" xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 200 300" width="20" height="20">
									<style type="text/css">
										.st0 {
											fill: #0acf83
										}

										.st1 {
											fill: #a259ff
										}

										.st2 {
											fill: #f24e1e
										}

										.st3 {
											fill: #ff7262
										}

										.st4 {
											fill: #1abcfe
										}
									</style>
									<title>Figma.logo</title>
									<desc>Created using Figma</desc>
									<path id="path0_fill" class="st0"
										d="M50 300c27.6 0 50-22.4 50-50v-50H50c-27.6 0-50 22.4-50 50s22.4 50 50 50z" />
									<path id="path1_fill" class="st1"
										d="M0 150c0-27.6 22.4-50 50-50h50v100H50c-27.6 0-50-22.4-50-50z" />
									<path id="path1_fill_1_" class="st2"
										d="M0 50C0 22.4 22.4 0 50 0h50v100H50C22.4 100 0 77.6 0 50z" />
									<path id="path2_fill" class="st3"
										d="M100 0h50c27.6 0 50 22.4 50 50s-22.4 50-50 50h-50V0z" />
									<path id="path3_fill" class="st4"
										d="M200 150c0 27.6-22.4 50-50 50s-50-22.4-50-50 22.4-50 50-50 50 22.4 50 50z" />
								</svg>Figma</a>
						</span> -->
					</span>
				</div>



			</li>
		</ul>
	</section>
</main>
